<template>
  <section class="uc-onb-card" aria-labelledby="uc-onb-card-title">
    <div class="uc-onb-card__head">
      <div class="uc-onb-card__icon" aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z" />
          <path d="M12 8v5" />
          <path d="M12 16.5h.01" />
        </svg>
      </div>

      <div class="uc-onb-card__text">
        <div class="uc-onb-card__meta">
          <span class="uc-onb-badge">Терміново</span>
          <span class="uc-onb-card__step">Онбординг · крок {{ currentStep }} з {{ steps.length }}</span>
        </div>
        <h2 id="uc-onb-card-title" class="uc-onb-card__title">Пройдіть онбординг</h2>
        <p class="uc-onb-card__desc">Без нього недоступне оформлення полісів.</p>
      </div>

      <SmartLink :route="{ name: 'onboardingPage' }" class="uc-onb-btn side-menu-logo">
        Пройти онбординг
        <span class="uc-onb-btn__circle" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 6l6 6-6 6" />
            <path d="M12 6l6 6-6 6" />
          </svg>
        </span>
      </SmartLink>

<!--      <component-->
<!--        :is="to ? 'router-link' : 'a'"-->
<!--        :to="to || undefined"-->
<!--        :href="to ? undefined : href"-->
<!--        class="uc-onb-btn"-->
<!--        @click.native="to && $emit('start')"-->
<!--        @click="!to && $emit('start')"-->
<!--      >-->
<!--        Пройти онбординг-->
<!--        <span class="uc-onb-btn__circle" aria-hidden="true">-->
<!--          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">-->
<!--            <path d="M6 6l6 6-6 6" />-->
<!--            <path d="M12 6l6 6-6 6" />-->
<!--          </svg>-->
<!--        </span>-->
<!--      </component>-->
    </div>

    <div
      class="uc-onb-progress"
      role="progressbar"
      aria-label="Прогрес онбордингу"
      aria-valuemin="0"
      :aria-valuemax="steps.length"
      :aria-valuenow="completed"
    >
      <div class="uc-onb-progress__fill" :style="{ width: progress + '%' }" />
    </div>

    <ol class="uc-onb-steps" :style="{ gridTemplateColumns: 'repeat(' + steps.length + ', minmax(0, 1fr))' }">
      <li v-for="(step, i) in steps" :key="step.label" class="uc-onb-step">
<!--        {{ i }}-->
<!--        {{ completed }}-->
<!--        {{ step }}-->
        <span v-if="i < completed" class="uc-onb-step__mark uc-onb-step__mark--done" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12l5 5L20 7" />
          </svg>
        </span>
        <span v-else-if="i === completed" class="uc-onb-step__mark uc-onb-step__mark--current" aria-hidden="true">
          <span class="uc-onb-step__dot" />
        </span>
        <span v-else class="uc-onb-step__mark uc-onb-step__mark--todo" aria-hidden="true">{{ i + 1 }}</span>

        <span class="uc-onb-step__text">
          <span class="uc-onb-step__label">{{ step.label }}</span>
          <span
            class="uc-onb-step__hint"
            :class="{ 'uc-onb-step__hint--current': i === completed }"
          >{{ hintFor(step, i) }}</span>
        </span>
      </li>
    </ol>
  </section>
</template>

<script>

import { SmartLink } from '@/shared/ui/link';
export default {
  name: 'OnboardingCard',
  props: {
    onboardingData: { type: Object, default: {} },
    /** Скільки кроків уже пройдено (0…steps.length) */
    //completed: { type: Number, default: 0 },
    /** Посилання на онбординг: route-об'єкт/рядок для router-link */
    to: { type: [String, Object], default: null },
    /** Звичайне посилання, якщо `to` не задано */
    href: { type: String, default: '/onboarding' },
    steps: {
      type: Array,
      default: () => [
        { label: 'Особисті дані', doneHint: 'Заповнено', currentHint: 'Заповніть профіль агента', todoHint: 'Профіль агента' },
        { label: 'Документи', doneHint: 'Перевірено', currentHint: 'Завантажте документи', todoHint: 'Паспорт, ІПН, реквізити' },
        { label: 'Підписання', doneHint: 'Підписано', currentHint: 'КЕП', todoHint: 'КЕП' }
      ]
    }
  },
  components: {
    SmartLink
  },
  data() {

  },
  computed: {
    completed() {
      // return 1;
      console.log('this.onboardingData', this.onboardingData)
        const step = this.onboardingData?.step ?? 0;
        let completed = 0;
        switch (step) {
          case 0:
          case 1:
          case 2:
          case 3:
            completed = 0;
            break;
          case 4:
          case 5:
            completed = 1;
            break;
          case 6:
          case 7:
          case 8:
            completed = 2;
            break;
          case 9:
            completed = this.onboardingData.status_id ? 3 : 2;
            break;
          default:
            completed = 0;
            break;
        }
        return completed;
     // return 3;
    },
    currentStep () {
      return Math.min(this.completed + 1, this.steps.length)
    },
    progress () {
      return this.steps.length ? (this.completed / this.steps.length) * 100 : 0
    }
  },
  methods: {
    hintFor (step, i) {
      if (i < this.completed) return step.doneHint
      if (i === this.completed) return step.currentHint
      return step.todoHint
    }
  }
}
</script>

<style scoped>
.uc-onb-card {
  --uc-red: #c93a2e;
  --uc-red-dark: #a3281f;
  --uc-red-tint: #fff2f0;
  --uc-red-track: #fbd9d4;
  --uc-red-soft: #fbe3df;
  --uc-ink: #373a3d;
  --uc-ink-soft: #494e53;

  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 16px;
  padding: 24px 28px;
  background: var(--uc-red-tint);
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 2px 5px rgba(201, 58, 46, 0.1);
  /*box-shadow: 0 8px 32px rgba(201, 58, 46, 0.1);*/
  font-family: Inter, system-ui, sans-serif;
  color: var(--uc-ink);
}

.uc-onb-card__head {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.uc-onb-card__icon {
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: var(--uc-red);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-onb-card__text {
  flex: 1 1 320px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.uc-onb-card__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.uc-onb-badge {
  padding: 2px 10px;
  border-radius: 999px;
  background: var(--uc-red);
  color: #fff;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}

.uc-onb-card__step {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: var(--uc-red-dark);
}

.uc-onb-card__title {
  margin: 0;
  font-family: 'IBM Plex Sans', system-ui, sans-serif;
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  color: var(--uc-ink);
}

.uc-onb-card__desc {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  color: var(--uc-ink-soft);
}

.uc-onb-btn {
  flex: 0 0 auto;
  height: 52px;
  padding: 0 10px 0 24px;
  display: inline-flex;
  align-items: center;
  gap: 14px;
  border-radius: 12px;
  background: var(--uc-red);
  color: #fff;
  text-decoration: none;
  font-family: 'IBM Plex Sans', system-ui, sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  transition: background-color 0.15s ease;
}

.uc-onb-btn:hover {
  background: var(--uc-red-dark);
  color: #fff;
}

.uc-onb-btn:focus-visible {
  outline: 2px solid var(--uc-red);
  outline-offset: 2px;
}

.uc-onb-btn__circle {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: #fff;
  color: var(--uc-red);
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-onb-progress {
  height: 6px;
  border-radius: 999px;
  background: var(--uc-red-track);
  overflow: hidden;
}

.uc-onb-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: var(--uc-red);
  transition: width 0.3s ease;
}

.uc-onb-steps {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 24px;
}

.uc-onb-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.uc-onb-step__mark {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  box-sizing: border-box;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-onb-step__mark--done {
  background: var(--uc-red);
  color: #fff;
}

.uc-onb-step__mark--current {
  border: 2px solid var(--uc-red);
  background: #fff;
}

.uc-onb-step__dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: var(--uc-red);
}

.uc-onb-step__mark--todo {
  background: var(--uc-red-soft);
  color: var(--uc-ink-soft);
  font-size: 13px;
  font-weight: 600;
}

.uc-onb-step__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.uc-onb-step__label {
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  color: var(--uc-ink);
}

.uc-onb-step__hint {
  font-size: 14px;
  line-height: 20px;
  color: var(--uc-ink-soft);
}

.uc-onb-step__hint--current {
  color: var(--uc-red-dark);
}

@media (max-width: 640px) {
  .uc-onb-card {
    padding: 20px;
    border-radius: 20px;
  }

  .uc-onb-btn {
    width: 100%;
    justify-content: space-between;
  }

  .uc-onb-steps {
    grid-template-columns: 1fr !important;
    gap: 12px;
  }
}
</style>
